export interface TransitionOptions {
  element: HTMLElement;
  before?: () => void;
  transition: () => void;
  after?: () => void;
  event?: string;
}

type TransitionOptionsWithDefaults = Omit<TransitionOptions, 'event'> & {
  event: string;
};

/**
 * A helper for handling transitions.
 */
export class Transition {
  private options: TransitionOptionsWithDefaults;
  private onEnd: (e: Event) => void;

  constructor(options: TransitionOptions) {
    this.options = {
      event: 'transitionend',
      ...options,
    };

    this.onEnd = this.handleEnd.bind(this);

    this.options.element.addEventListener(this.options.event, this.onEnd);

    // Fire a callback function before the transition starts
    this.options.before?.();

    // Perform the transition
    this.options.transition();
  }

  private handleEnd(e: Event): void {
    // Ignore events that bubble up from child elements
    if (e.target !== this.options.element) {
      return;
    }

    // Remove the event listeners to avoid duplicate behaviors
    this.destroy();

    // Fire a callback function after the transition ends
    this.options.after?.();
  }

  /**
   * Public
   */
  public destroy(): void {
    this.options.element.removeEventListener(this.options.event, this.onEnd);
  }
}
